import "./WorkCardStyle.css"

import proj1 from"../components/asserts/arabia1.png"
import proj2 from"../components/asserts/convert2.png"
import proj3 from"../components/asserts/dson3.png"
import proj4 from"../components/asserts/jyngmydowg4.png"
import proj5 from"../components/asserts/london5.png"
import proj6 from"../components/asserts/nukes6.png"
import proj7 from"../components/asserts/scrib7.png"
import proj8 from"../components/asserts/squareX8.png"
import proj9 from"../components/asserts/usd9.png"

const WorkCardData = [
  {
    imgsrc: proj1,
    title: "Ecommerce Website design",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever",
    view:"https://www.youtube.com/watch?v=0h2b4ftbZcU&t=185s"
  },

  {
    imgsrc: proj2,
    title: "Ecommerce Website design",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since ",
    view:"https://www.youtube.com/watch?v=0h2b4ftbZcU&t=185s"
  },

  {
    imgsrc: proj3,
    title: "Ecommerce Website design",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since ",
    view:"https://www.youtube.com/watch?v=0h2b4ftbZcU&t=185s"
  },

  {
    imgsrc: proj4,
    title: "Ecommerce Website design",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    view:"https://www.youtube.com/watch?v=0h2b4ftbZcU&t=185s"
  },

  {
    imgsrc: proj5,
    title: "Ecommerce Website design",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    view:"https://www.youtube.com/watch?v=0h2b4ftbZcU&t=185s"
  },

  {
    imgsrc: proj6,
    title: "Ecommerce Website design",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    view:"https://www.youtube.com/watch?v=0h2b4ftbZcU&t=185s"
  },

  {
    imgsrc: proj7,
    title: "Ecommerce Website design",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    view:"https://www.youtube.com/watch?v=0h2b4ftbZcU&t=185s"
  },

  {
    imgsrc: proj8,
    title: "Ecommerce Website design",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    view:"https://www.youtube.com/watch?v=0h2b4ftbZcU&t=185s"
  },

  {
    imgsrc: proj9,
    title: "Ecommerce Website design",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,",
    view:"https://www.youtube.com/watch?v=0h2b4ftbZcU&t=185s"
  },



]

export default WorkCardData;